import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  getOrganizationSchemaAdditionalFields,
  organizationSchema,
} from "./organization";
import { getPersonSchemaAdditionalFields, personSchema } from "./person";

export const holdingOwnerBaseSchema = z.object({
  primary: z.boolean(),
  share: z.number(),
});

export const holdingOwnerSchema = z.union([
  holdingOwnerBaseSchema.extend({
    person: personSchema,
  }),
  holdingOwnerBaseSchema.extend({
    organization: organizationSchema,
  }),
]);

export type HoldingOwner = z.infer<typeof holdingOwnerSchema>;

export function getHoldingOwnerSchemaAdditionalFields(additionalFields: {
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof holdingOwnerSchema {
  return z.union([
    holdingOwnerBaseSchema.extend({
      person: getPersonSchemaAdditionalFields(additionalFields),
    }),
    holdingOwnerBaseSchema.extend({
      organization: getOrganizationSchemaAdditionalFields(additionalFields),
    }),
  ]);
}
